import { OrderByEnum } from '../../../common/core/data-access/pagination/enums/order-by.enum';

export interface Item {
  tableHeader?: string;
  headers: string[]; // Array of header names for the table
  dataKeys?: string[]; // Optional array of data keys to target data keys values
  data?: any[]; // Optional array of data objects to display in the table
}

export interface DeprecatedPaginationParameters {
  sortColumn?: string | undefined;
  sortOrder?: string | undefined;
  searchField?: string | undefined;
  SearchKeyword?: string | undefined;
  page?: number | undefined;
  pageSize?: number | undefined;
  order?: string | undefined;
  orderBy?: string | undefined;
  IsActive?: boolean | undefined;
}

export const defaultPaginationParameters: DeprecatedPaginationParameters = {
  page: 1,
  pageSize: 10,
  orderBy: 'CreatedOnUtc',
  order: OrderByEnum.DESCEDING,
};

export interface DeprecatedPaginationResponse {
  hasNext: boolean;
  hasPrevious: boolean;
  numberOfPages: number;
  order: string;
  page: number;
  pageSize: number;
  totalItemCount: number;
}

export interface ISearchFieldEvent {
  fieldName: string;
  keyword: string;
}

export interface IValidationErrors {
  [fieldName: string]: string[];
}
